import {
  defineEnvSchema,
  makeBooleanVar,
  makeNumberVar,
  makeStringVar
} from '@pickleballinc/lib/env';

export const systemEnvSchema = defineEnvSchema({
  DOCKER_BUILD: makeBooleanVar({ required: false, default: false }),
  DEBUG_ENV_VAR: makeBooleanVar({ required: false, default: false }),
  BUILD_ID: makeStringVar({ required: true, minLength: 20 }),
  NODE_ENV: makeStringVar({ required: true, choices: ['development', 'production', 'test'] }),
  NEXT_RUNTIME: makeStringVar({ required: false, choices: ['nodejs', 'edge'], default: 'nodejs' })
});

export const publicEnvSchema = defineEnvSchema({
  NEXT_PUBLIC_APP_ENV: makeStringVar({
    required: true,
    choices: ['dev', 'prod', 'test'],
    default: 'dev'
  }),
  NEXT_PUBLIC_IMAGE_CDN_URL: makeStringVar({ required: true, match: 'url' }),
  NEXT_PUBLIC_HOME_ROOT_URL: makeStringVar({ required: true, minLength: 9 }),
  NEXT_PUBLIC_TINY_URL: makeStringVar({ required: true, match: 'url' }),
  NEXT_PUBLIC_SENTRY_DSN: makeStringVar({ required: false, match: 'url' })
});

export const serverEnvSchema = defineEnvSchema({
  API_URL: makeStringVar({ required: true, mask: true, match: 'url' }),
  API_URL_V2: makeStringVar({ required: true, mask: true, match: 'url' }),
  API_KEY: makeStringVar({ required: true, mask: true, match: 'uuid' }),
  SENTRY_DEBUG: makeBooleanVar({ required: false, default: false }),
  SENTRY_SAMPLE_RATE: makeNumberVar({ required: false, default: 1.0 }),
  SENTRY_TRACES_SAMPLE_RATE: makeNumberVar({ required: false, default: 1.0 })
});
